import React from 'react';

/* Burnout article infographic ("The Crisis" / "The Solution").
   Styles: src/styles/pages/blog.css (.burnout-info). Stats count up via the
   global motion layer (data-count); the prerendered text is the final value. */

function StatPill({ value, suffix, label }) {
  return (
    <div className="burnout-info__stat">
      <p className="burnout-info__num">
        <span data-count={value}>{value}</span><span className="burnout-info__suffix">{suffix}</span>
      </p>
      <p className="burnout-info__label">{label}</p>
    </div>
  );
}

function WorkflowChip({ icon, label }) {
  return (
    <li className="burnout-info__chip">
      <i className={`fa-solid ${icon}`} aria-hidden="true" />
      <span>{label}</span>
    </li>
  );
}

function BurnoutInfographic() {
  return (
    <div className="burnout-info">
      <span className="burnout-info__tag burnout-info__tag--crisis">The Crisis</span>

      <div className="burnout-info__card">
        <p className="burnout-info__kicker"><span className="dot-live" aria-hidden="true" />Canada Healthcare 2026</p>
        <p className="burnout-info__title">
          2 in 5 Healthcare<br />Workers Are <em>Burned Out.</em>
        </p>
        <p className="burnout-info__lead">
          AI automation can save 20+ hours/week<br />and reduce burnout risk by 74%.
        </p>

        <div className="burnout-info__stats" data-reveal-stagger>
          <StatPill value="42" suffix="%" label="say workload is unsustainable" />
          <StatPill value="30" suffix="min" label="saved per provider per day" />
          <StatPill value="74" suffix="%" label="lower burnout risk with AI docs" />
        </div>

        <ul className="burnout-info__chips" aria-label="Workflows">
          <WorkflowChip icon="fa-file-medical" label="Smart Intake" />
          <WorkflowChip icon="fa-robot" label="AI Documentation" />
          <WorkflowChip icon="fa-paper-plane" label="Auto Referrals" />
          <WorkflowChip icon="fa-clock" label="Follow-up Bot" />
        </ul>
      </div>

      <span className="burnout-info__tag burnout-info__tag--solution">The Solution</span>
    </div>
  );
}

export default BurnoutInfographic;
